export default {
  baseUrl: {
    ayapi_dev: '/api',
    ayapi_pro: '/api',
    wxapi_dev: 'http://localhost:36607',
    wxapi_pro: 'https://wx.mycits.cn'
  }
}
